import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoginRequestDto } from '../../dtos/login-request.dto';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AdminService } from '../../../admin/services/admin.service';
import { AdminFormFactory } from '../../../admin/mappers/admin-form.factory';
import { RegisterAdminLegacyDto } from '../../../admin/dtos/register-admin-legacy.dto';
import { ErrorService } from '../../../../core/services/error.service';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorCodes } from '../../../../core/enums/error-codes.enum';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MigrateAdminConfirmDialog } from '../migrate-admin-confirm/migrate-admin-confirm.dialog';
import { CustomerService } from '../../../customer/services/customer.service';

@Component({
  selector: 'app-migrate-admin',
  imports: [
    MatFormFieldModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './migrate-admin.dialog.html',
  styleUrl: './migrate-admin.dialog.scss'
})
export class MigrateAdminDialog implements OnInit{
  adminLegacyForm!: FormGroup;
  error?: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    loginRequestDto: LoginRequestDto,
  }, private fb: FormBuilder, private customerService: CustomerService, private translocoService: TranslocoService, private adminService: AdminService, private dialogRef: MatDialogRef<MigrateAdminDialog>, private errorService: ErrorService, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.adminLegacyForm = AdminFormFactory.createAdminLegacyForm(this.fb, this.data.loginRequestDto);
  }

  close(): void {
    this.dialogRef.close();
  }

  add(): void {
    if (this.adminLegacyForm.invalid) {
      this.adminLegacyForm.markAllAsTouched();
      return;
    }

    let registerAdminLegacyDto: RegisterAdminLegacyDto = this.adminLegacyForm.value;

    this.customerService.lookupCustomerId(registerAdminLegacyDto.customerKey).subscribe({
        next: (customerParameter) => {
          this.adminService.registerAdminLegacy(customerParameter.customerId, registerAdminLegacyDto).subscribe({
            next: () => {
              this.dialog.open(MigrateAdminConfirmDialog, {autoFocus: false}).afterClosed().subscribe((_) => {this.dialogRef.close(customerParameter.customerId);});
            },
            error: (error) => {
              if (error.status == 401) {
                if (error.error?.errorCode && error.error.errorCode == ErrorCodes.adminAlreadyExists) {
                  this.error = this.translocoService.translate('error.admin_already_exists');
                  return;
                }

                this.error = this.translocoService.translate("error.calit_unauthorized");
                return;
              }

              this.errorService.handleError(error, this.translocoService.translate('error.title.add_admin'));
            }
          });
        },
        error: (error) => {
          this.error = this.errorService.handleError(error, this.translocoService.translate('error.title.lookup_customer_id'));
        }
      }
    );
  }
}
